import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Amitabh Raj </span>
            from <span className="purple">India.</span>
            <br />
            I am currently Working on real-time Personalised Traviling Package Booking Website, where I am gaining
            hands-on experience in web development and cloud computing.
            <br />
            My programming journey started with a deep curiosity about how drones are made,
            which led me to explore coding. An unexpected internship introduced me to
            web development, and since then, I have been passionately working with
            technologies like Python, Django, JavaScript, and AWS EC2.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Cricket on Weekends
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring New Tech Trends
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling and Experiencing Different Cultures
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Try it, not for success, but for the satisfaction of the effort"
          </p>
          <footer className="blockquote-footer">Amitabh Raj</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
